<template>
  <div>
    <b-button
      class="mr-2"
      size="sm"
      variant="outline-success"
      @click="$emit('addBatch')"
      :disabled="disabled"
    >
      <i class="el-icon-plus" />
      {{ $l('INDEX.btn_add') || '添加' }}
    </b-button>
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } }
}
</script>
